


























































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import EditUserExpresssInfo from './edit-userexpressinfo.vue'
import storeaddressInfo from '@/store/entities/back-storeaddress-list'
import Enums from '@/lib/enums'
import DateUtils from '@/common/js/DateUtils'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import moment from 'moment'
Vue.use(Preview);

class PageUserExpressInfoRequest extends PageRequest {
    shipment: string;
    beginTime?: Date;
    endTime?: Date;
    orderNumber: string;
    receiveStatus?: number;
    isRelated: string;
    whetherHandle: string;
    userUploadImageGuid: string;
    whetherAbroad?: boolean;
    storeId?: number;
    isOrder?: boolean;
    isRelatedStock: string;
    constructor() {
        super();
        this.isRelated = "false";
        this.isRelatedStock = "false";
        this.receiveStatus = 1;
        this.whetherHandle = "false";
    }
}

@Component({
    name:"expressUserInfo",
    components: { EditUserExpresssInfo }
})
export default class UserExpressInfo extends AbpBase {
    editModalShow: boolean = false;
    
    shipmentReceiveStatus = Enums.getEnum(Enums.ShipmentReceiveStatus, true);
    whetherStatus = Enums.getEnum(Enums.WhetherStringStatus, true);
    whetherhandleList = Enums.getEnum(Enums.WhetherHandleStatus, true);
    whetherAbroadList = Enums.getEnum(Enums.WhetherAbroadStatus, true);
    pagerequest: PageUserExpressInfoRequest = new PageUserExpressInfoRequest();
    //creationTime: Date[] = [];
    creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
    isDisplay: boolean = false;
    storeaddressList: Array<storeaddressInfo> = [];
    imageGuid: string = "";
    get list() {
        return this.$store.state.expressuserinfo.list;
    };
    get loading() {
        return this.$store.state.expressuserinfo.loading;
    }

    pageChange(page: number) {
        this.$store.commit('expressuserinfo/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('expressuserinfo/setPageSize', pagesize);
        this.getpage();
    }

    changestatus(a: any) {
        this.pagerequest.storeId = null;
        if (a == true) {
            this.getData();
            this.isDisplay = true;
        }
        else {
            this.isDisplay = false;
        }
    }

    async operationData(name: any, data: any) {
        if (name == '修改信息') {
            this.pagerequest.userUploadImageGuid = data.userUploadImageGuid;
            this.$store.state.expressuserinfo.userExpressInfo = data;
            this.editModalShow = true;
        }
        var _this: any = this;
        _this.$previewRefresh();
    }
    async searchPage() {
        this.$store.state.user.currentPage=1;
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;

        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        if (this.creationTime.length > 0) {
            this.pagerequest.beginTime = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endTime = this.creationTime[1];
        }

        await this.$store.dispatch({
            type: 'expressuserinfo/getAll',
            data: this.pagerequest
        })
    }

    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        this.storeaddressList.push(a);

    }


    get pageSize() {
        return this.$store.state.expressuserinfo.pageSize;
    }
    get totalCount() {
        return this.$store.state.expressuserinfo.totalCount;
    }
    get currentPage() {
        return this.$store.state.expressuserinfo.currentPage;
    }
    columns = [{
        title: '快递单号',
        key: 'shipment',
        width: 200,
        fixed: 'left',
    }, {
        title: '订单编号',
        key: 'orderNumber',
        width: 200,
    }, {
        title: '仓库名称',
            width: 200,
            render: (h: any, params: any) => {
                return h('span', params.row.warehouseName ? params.row.warehouseName : params.row.storeName)
            }
    }, {
        title: '图片',
        key: 'imageGuid',
        width: 150,
        render: (h: any, params: any) => {
            if (params.row.imageGuid) {
                var data = { imageGuid: params.row.imageGuid, url: null };
                this.$store.commit('expressuserinfo/getImgUrl', data);
                var url = data.url;;
                return h('img', {
                    style: {
                        width: "50px",
                        height: "50px",
                        verticalAlign: "middle"
                    },
                    attrs: {
                        src: url,
                        preview: params.row.id,
                        "preview-text": params.row.shipment
                    }
                });

            } else {
                return h('span', "");
            }
        }
        }, {
            title: '是否标为已处理',
            key: 'whetherHandle',
            width: 120,
            render: (h: any, params: any) => {
                return h('span', params.row.whetherHandle ? this.L('是') : this.L('否'))
            }
        },
        {
            title: '物品图片',
            key: 'goodsImageGuid',
            width: 150,
            render: (h: any, params: any) => {
                if (params.row.goodsImageGuid) {
                    var datas = { goodsImageGuid: params.row.goodsImageGuid, urls: null };
                    this.$store.commit('backlogistics/getGoodsImgUrl', datas);
                    var urls = datas.urls;
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: urls,
                            preview: params.row.id + "_",
                            "preview-text": params.row.goodsImageGuid
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },{
            title: '用户上传图片',
            key: 'userUploadImageGuid',
            width: 150,
            render: (h: any, params: any) => {
                if (params.row.userUploadImageGuid) {
                    var data = { imageGuid: params.row.userUploadImageGuid, url: null };
                    this.$store.commit('expressuserinfo/getImgUrl', data);
                    var url = data.url;;
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: params.row.id,
                            "preview-text": params.row.shipment
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        }, {
        title: '状态',
        width: 140,
        key: 'receiveStatus',
        render: (h: any, params: any) => {
            return h('span', Enums.ShipmentReceiveStatus.filter(function (item) { return item.value == params.row.receiveStatus })[0].name);
        }
    }, {
        title: '创建时间',
        key: 'createTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
        }
    }, {
        title: '备注',
        width: 200,
        key: 'reMark',
    }, {
        title: '签收时间',
        key: 'signForTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.signForTime ? DateUtils.formatLongDate(new Date(params.row.signForTime)) : '');
        }
        }, {
            title: '拒收时间',
            key: 'rejectionTime',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', params.row.rejectionTime ? DateUtils.formatLongDate(new Date(params.row.rejectionTime)) : '');
            }
        }, {
            title: '操作',
            width: 100,
            fixed: 'right',
            key: 'id',
            render: (h: any, params: any) => {
                var _this = this;
                var menu = [];
                menu.push("修改信息");
                return h('Dropdown', {
                    props: {
                        transfer: true,
                        trigger: 'click',
                    },
                    on: {
                        'on-click': (name) => {
                            _this.operationData(name, params.row);
                        }
                    }

                }, [
                    h('Button',
                        {
                            domProps: {
                                innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                            },
                            props: {
                                type: 'primary',
                            }

                        }),
                    h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                        return h('DropdownItem', { props: { name: item } }, item)
                    })
                    )]);
            }
        }  ]
    async created() {

        this.getpage();
    }
}
